var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.1333V19.1333C20 18.0725 19.5786 17.0551 18.8284 16.3049C18.0783 15.5548 17.0609 15.1333 16 15.1333H8C6.93913 15.1333 5.92172 15.5548 5.17157 16.3049C4.42143 17.0551 4 18.0725 4 19.1333V21.1333",
    stroke: "#13675f",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.1333C14.2091 11.1333 16 9.34247 16 7.13333C16 4.92419 14.2091 3.13333 12 3.13333C9.79086 3.13333 8 4.92419 8 7.13333C8 9.34247 9.79086 11.1333 12 11.1333Z",
    stroke: "#13675f",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.36334a7e75221f346d54b70d3a9da203.svg";
export { ForwardRef as ReactComponent };